/* src/app/core/modules/shared/components/modal-state/modal-state.component.scss */
/*# sourceMappingURL=/avvera/dev/modal-state.component.css.map */
